import { FC } from "react";
import { IconPropsType } from ".";

export const Plus: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.895312 4.28H4.27969V0.90125C4.27969 0.623125 4.50469 0.390625 4.78281 0.390625H5.21594C5.49406 0.390625 5.72 0.623125 5.72 0.90125V4.28H9.105C9.38312 4.28 9.60906 4.505 9.60906 4.78313V5.21875C9.60906 5.49656 9.38281 5.72063 9.105 5.72063H5.72V9.11156C5.72 9.38938 5.49406 9.60969 5.21594 9.60969H4.78281C4.50469 9.60969 4.27969 9.38938 4.27969 9.11156V5.72063H0.895312C0.617187 5.72063 0.390625 5.49656 0.390625 5.21875V4.78313C0.390625 4.505 0.617187 4.28 0.895312 4.28Z"
        fill={props.color}
      />
    </svg>
  );
};
